import React, { useRef } from 'react'
import './scss/style.scss'
import AppProvider, { useAppContext } from './context/AppProvider'
import { CToaster } from '@coreui/react-pro'
import AppRouter from './routing/AppRouter'

function App() {
  const { toast } = useAppContext()
  const toaster = useRef()

  return (
    <>
      <AppRouter />
      <CToaster ref={toaster} push={toast} placement="top-end" />
    </>
  )
}

const AppWithContext = () => {
  return (
    <AppProvider>
      <App />
    </AppProvider>
  )
}
export default AppWithContext
